import React from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'antd';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import member1 from '../../static/member1.webp';
import member2 from '../../static/member2.webp';

const keyMembers = [
  {
    photo: member1,
    name: '刘  虹',
    title: '创始人 · 负责人',
    desc: '郁金香陪伴创始人、绿城爱心基金会秘书长、浙江省婚姻家庭协会副会长、民间抗郁行动联盟联合发起人、国家二级心理咨询师。',
  },
  {
    photo: member2,
    name: '何季颖',
    title: '执行院长',
    desc: '郁金香成长学苑执行院长，艺术治疗师、情感婚姻关系咨询师，郁金香《和你有约》主持人。',
  },
];

const otherMembers = [
  { name: '刘  隽', title: '理事' },
  { name: '宋建平', title: '理事' },
  { name: '张屠莹', title: '监事' },
];

const BoardMembers: React.FC = () => {
  const history = useHistory();

  return (
    <PageLayout history={history} children={[]} Content={
      <div className="page-container members-page">
        <h1 className="page-title">理事会成员</h1>

        {/* Key members with photos */}
        <Row gutter={[32, 32]} className="key-members">
          {keyMembers.map((m) => (
            <Col xs={24} sm={12} key={m.name}>
              <div className="member-card">
                <div className="member-card__photo-wrap">
                  <img src={m.photo} alt={m.name} className="member-card__photo" />
                </div>
                <div className="member-card__info">
                  <h2 className="member-card__name">{m.name}</h2>
                  <div className="member-card__title-badge">{m.title}</div>
                  <p className="member-card__desc">{m.desc}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* Other members */}
        <h2 className="section-title" style={{ marginTop: 48 }}>其他成员</h2>
        <Row gutter={[16, 16]}>
          {otherMembers.map((m) => (
            <Col xs={24} sm={8} key={m.name}>
              <div className="other-member-card">
                <div className="other-member-card__avatar">
                  {m.name.trim()[0]}
                </div>
                <div>
                  <div className="other-member-card__name">{m.name}</div>
                  <div className="other-member-card__role">{m.title}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    } />
  );
};

export default BoardMembers;
